<div id="recovery-card" class="dx-card content">
  <dx-validation-group>
    <div class="recovery-header">
      <img class="logo" [height]="50" [src]="'/assets/images/tracagri_logo_color.svg'">
      <div class="text">Changer votre mot de passe.</div>
    </div>
    <div class="dx-field">
      <dx-text-box [(value)]="password" mode="password" placeholder="Nouveau Mot de Passe" width="100%">
        <dx-validator>
          <dxi-validation-rule type="required"></dxi-validation-rule>
          <dxi-validation-rule type="stringLength" [min]="8" [max]="150"
                               message="La longueur minimale du mot de passe est de 8 caractères"></dxi-validation-rule>
        </dx-validator>
      </dx-text-box>
    </div>
    <div class="dx-field">
      <dx-text-box mode="password" placeholder="Confirmation du Mot de Passe" width="100%">
        <dx-validator>
          <dxi-validation-rule type="required"></dxi-validation-rule>
          <dxi-validation-rule
            type="compare"
            [comparisonTarget]="passwordValue"
            message="La confirmation du mot de passe ne correspond pas">
          </dxi-validation-rule>
        </dx-validator>
      </dx-text-box>
    </div>
    <div class="dx-field">
      <dx-button type="default" text="Changer" (onClick)="onChangeClick($event)" width="100%"></dx-button>
    </div>
    <div class="dx-field">
      <a routerLink="/login">Se Connecter?</a>
    </div>
  </dx-validation-group>
</div>

<dx-load-panel
  shadingColor="rgba(0,0,0,0.2)"
  [position]="{ of: '#recovery-card' }"
  [(visible)]="loadIndicatorVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [closeOnOutsideClick]="false">
</dx-load-panel>
